import { defineStore } from 'pinia'
import { ref } from 'vue';
import {httpPost} from "../api/http_caller";
import {cloneDeep} from "lodash";
import Questionario from "../components/questionario/Questionario.class";

export const useDefaultStore = defineStore('default', () => {
  // gestisce la visualizzazione della modale di login
  const modalLogin = ref(false);
  const feacturesList = ref({})
  // tiene sincronizzato il ruolo attivo
  const aclRules = ref({
    isNotaio: false,
    isCittadino: false,
    isGestionale: false
  })

  return {modalLogin, aclRules, feacturesList}
})

export const usePraticaStore = defineStore('pratica', () => {
  const documentStore = useDocumentStore();
  const soggettoStore = useSoggettoStore();

  // ID della pratica
  const praticaID = ref(0)
  const isDettagliPraticaModaleControlloModifiche = ref(false)
  // estensioni accettate dai upload files
  const documentExtensionAccepted = ref(['doc', 'docx', 'rtf', 'odt', 'pdf', 'jpeg', 'jpg', 'png', 'tiff', 'xls', 'xlsx', 'ods', 'eml', 'gif', 'p7m', 'xml']);
  // Dettagli della pratica
  const datiDettagli = ref({});
  // Tipo di utente connesso , notaio|cittadino
  const tipoUtenteConnesso = ref('');
  // nome da mostrare in alcune casistiche (ex. aggiunta note ai file) dell'utente connesso
  const nomeUtenteConnesso = ref('')

  /**
   * Ri inizializza soggetti, documenti, documenti atti pratica, e checklist abbinate ai soggetti
   * Utilizzato per esempio in fase di crezione/modifica checklist poichè comporta aggiunte/modifiche anche per
   * soggetti e documenti
   * @returns {Promise<void>}
   */
  async function onReInitPratica() {
    let soggettiParsing = null;
    let getDatiPratica = await httpPost(
      'Pratica',
      'getApi',
      {pratica_id: praticaID.value},
      {headers: {'Content-Type': 'multipart/form-data'}, messages: 'error', loading: false})

    if(getDatiPratica.esito === 'ok') {
      let documentiAtti = getDatiPratica[".doc"].response_parameters.calc_found_rows > 0 ? getDatiPratica['.doc'].response_parameters.rows : [];
      documentStore.documentiAtto = documentiAtti;
      documentStore.documentiAttoDefault = documentiAtti;

      let documentiAttiPratica = getDatiPratica[".documenti_atti_pratica"].response_parameters.calc_found_rows > 0 ?  getDatiPratica['.documenti_atti_pratica'].response_parameters.rows : []
      documentStore.documentiAttoPratica = documentiAttiPratica;
      documentStore.documentiAttoPraticaDefault = documentiAttiPratica;

      let getQuestionariRichiesti = await httpPost('Questionario','getQuestionariRichiesti',{pratica_id: praticaID.value}, {
        messages: 'error',
        loading: false,
        headers: {"Content-Type": "multipart/form-data"},
      });

      soggettiParsing = cloneDeep(getDatiPratica['.soggetti'].response_parameters.rows);
      if (soggettiParsing) {
        (getQuestionariRichiesti.questionari).forEach(function (questionario) {
          (soggettiParsing).forEach(function (soggetto, sogKey) {
            if (Number(soggetto.soggetto_id) === Number(questionario.soggetto_id)) {
              soggettiParsing[sogKey].checkList = questionario;
            }
          });
        });
        soggettoStore.store_soggetti = soggettiParsing;
        soggettoStore.store_soggetti_default = soggettiParsing;
      } else {
        soggettoStore.store_soggetti = [];
        soggettoStore.store_soggetti_default = [];
      }
    }
  }

  return { praticaID, isDettagliPraticaModaleControlloModifiche, documentExtensionAccepted, datiDettagli, tipoUtenteConnesso, nomeUtenteConnesso, onReInitPratica }
})

export const useSoggettoStore = defineStore('soggetto', () => {
  // Soggetti della pratica
  const store_soggetti = ref({})
  // Rubrica Soggetti delle pratiche
  const rubricaSoggetti = ref([])
  // Soggetti della pratica
  const store_soggetti_default = ref({})
  // Rubrica Soggetti delle pratiche
  const rubricaSoggettiDefault = ref([])

  const rubricaSoggettoFilters = ref({
    cod_fiscale: {value: ''},
    soggetto: {value: ''},
    email: {value: ''}
  })
  const rubricaSoggettoFiltersDefault = ref([])

  // Titolo e ID della Modale di Upsert del Soggetto
  const modalSoggettoTitle = ref('Nuovo Soggetto')
  const modaleSoggettoID =  ref('nuovo_soggetto')

  return {store_soggetti, store_soggetti_default, rubricaSoggetti, rubricaSoggettiDefault, modalSoggettoTitle, modaleSoggettoID, rubricaSoggettoFilters, rubricaSoggettoFiltersDefault}
})

export const useDocumentStore = defineStore('document', () => {
  // Tabella Documenti
  const documentiAtto =  ref([]);
  const documentiAttoDefault= ref([]);
  // Documenti della tab atti della pratica
  const documentiAttoPratica = ref([]);
  const documentiAttoPraticaDefault = ref([]);

  return {documentiAtto, documentiAttoDefault, documentiAttoPratica, documentiAttoPraticaDefault}
})

export const useChecklistStore = defineStore('checklist', () => {
  const praticaStore = usePraticaStore();
  const soggettoStore = useSoggettoStore();

  const questionarioAttivo = ref({
    id: null,
    status: null,
    titolo: null,
    messaggioInformativo: null
  });

  const questionarioTemplate = ref({
    atom_components: {
      version: '',
      title: '',
      note: ''
    },
    created_at: '',
    finished_at: '',
    is_to_do: '',
    inviato_a: '',
    questionario_id: '',
    soggetto_id: '',
    validazione_notaio_at: ''
  });

  const questionarioAttivoStatus = ref(null);
  const questionari = ref([]);
  const questionario = ref([]);
  const questionariRichiesti = ref([]);
  // attività che il notaio deve completare
  const notaioDaFare = ref([]);
  // attività che il cittadino deve completare
  const cittadinoDaFare = ref([]);
  // checklist template
  const checkList = ref({});
  const isQuestionariDaCompletare = ref(false)
  const controlloDisabilitaPerBottoneValidazione = ref(false)
  const risposteDelQuestionario = ref(null)
  const questionarioIdAttivo = ref(null)
  const questionarioDefault = ref([])
  const is_show_checklist = ref(true)

  /**
   * utilizzata per ricaricare le checklist assegnate alla lista dei soggetti
   * @return {Promise<void>}
   */
  async function reloadQuestionariRichiestiPerSoggetto() {
    let responseQuestionariRichiesti = await httpPost(
      'Questionario',
      'getQuestionariRichiesti',
      {'pratica_id': praticaStore.praticaID},
      {headers: {"Content-Type": "multipart/form-data"}, messages: false, loading: false}
    )

    if (responseQuestionariRichiesti && responseQuestionariRichiesti.esito === 'ok') {
      if (responseQuestionariRichiesti.questionari) {
        notaioDaFare.value = [];
        cittadinoDaFare.value = [];
      }

      (responseQuestionariRichiesti.questionari).forEach(function (questionario) {
        isQuestionariDaCompletare.value = questionario.is_to_do;

        if (questionario.is_to_do) {
          notaioDaFare.value.push(questionario)
          if(praticaStore.datiDettagli.chiusa.value !== 1){
            cittadinoDaFare.value.push(questionario)
          }
        }

        let soggettiVuexData = cloneDeep(soggettoStore.store_soggetti);
        if(soggettiVuexData && Object.keys(soggettiVuexData).length > 0) {
          (soggettiVuexData).forEach(function (soggetto, sogKey) {
            if (Number(soggetto.soggetto_id) === Number(questionario.soggetto_id)) {
              soggettiVuexData[sogKey].checkList = questionario;
            }
          });

          soggettoStore.store_soggetti = soggettiVuexData;
        }
      });
    }
  }

  /**
   * Si occupa di richiedere le info sui questionari richiesti
   * E inserisce (se presente) i dati della checklist per ogni soggetto
   * @param params
   * @returns {Promise<void>}
   */
  async function onResponseQuestionariRichiesti(params = {init: true}) {
    let responseQuestionariRichiesti = await httpPost(
      'Questionario',
      'getQuestionariRichiesti',
      (params && params.objectToRequest) ? params.objectToRequest : {'pratica_id': praticaStore.praticaID},
      {headers: {"Content-Type": "multipart/form-data"}, messages: false, loading: false}
    )

    if (responseQuestionariRichiesti && responseQuestionariRichiesti.esito === 'ok') {
      questionari.value = cloneDeep(responseQuestionariRichiesti.questionari)
      questionariRichiesti.value = cloneDeep(responseQuestionariRichiesti.questionari)

      if (responseQuestionariRichiesti.questionari && params.init) {
        notaioDaFare.value = [];
        cittadinoDaFare.value = [];
      }

      (responseQuestionariRichiesti.questionari).forEach(function (questionario) {
        isQuestionariDaCompletare.value = questionario.is_to_do;

        if (params.init && questionario.is_to_do) {
          notaioDaFare.value.push(questionario)
          if(Number(praticaStore.datiDettagli.chiusa.value) !== 1){
            cittadinoDaFare.value.push(questionario)
          }
        }

        let soggettiVuexData = cloneDeep(soggettoStore.store_soggetti);
        if(soggettiVuexData && Object.keys(soggettiVuexData).length > 0) {
          (soggettiVuexData).forEach(function (soggetto, sogKey) {
            if (Number(soggetto.soggetto_id) === Number(questionario.soggetto_id)) {
              soggettiVuexData[sogKey].checkList = questionario;
            }
          });

          soggettoStore.store_soggetti = soggettiVuexData;
        }
      });

      if(params && params['is_return'] !== undefined) {
        return responseQuestionariRichiesti.questionari
      }
    }
  }

  /**
   * Recupero la matrice della checklist (Lato Notaio)
   *
   * @param {Object} modello=null Oggetto del modello se presente per recuperare dati (es. parent_id)
   */
  async function  getChecklist(modello = null) {
    let params = praticaStore.praticaID ? {pratica_id: praticaStore.praticaID}  : {};
    if (modello) {
      params.parent_id = modello.parent_id;
    }
    let getCheckList = await httpPost('Questionari', 'getChecklist', params , {
      headers: {'Content-Type': 'multipart/form-data'},
      messages: false,
      loading: false
    });
    if (getCheckList && getCheckList.esito === 'ok') {
      checkList.value = getCheckList.questionari.checklist
    }
  }

  function onControlloDisabilitaPerCtaCompletaValidazione() {
    let elementiDelQuestionario = cloneDeep(risposteDelQuestionario.value);
    let esciDalLoop = false;

    if (elementiDelQuestionario) {
      let isBlockInvioDocumenti = true;
      (elementiDelQuestionario).forEach(function (element) {
        if (element.value && !esciDalLoop) {
          element.value.forEach(function (item) {
            if(Number(item.bozza) === 1 && item.filesystem_name) {
              isBlockInvioDocumenti = false;
            }

            if (praticaStore.tipoUtenteConnesso === 'notaio') {
              isBlockInvioDocumenti = false;
            }
          });
        }
      });

      controlloDisabilitaPerBottoneValidazione.value = isBlockInvioDocumenti;
    }
  }

  function onReInitQuestionario(params) {
    let elementiDelQuestionario = cloneDeep(risposteDelQuestionario.value);
    let elementoRicercato = Questionario._searchByHash(elementiDelQuestionario, {el: params.data});

    Object.keys(params.data).forEach(function (itemKey) {
      elementoRicercato[itemKey] = params.data[itemKey];
    });

    if (params.file) {
      elementoRicercato['value'].forEach(function (element) {
        if ((element.document_id === params.file.document_id) || (element.documento_id === params.file.document_id)) {
          Object.keys(element).forEach(function (elementKey) {
            element[elementKey] = params.file[elementKey];
          });
        }
      });
    }

    risposteDelQuestionario.value = elementiDelQuestionario;
  }

  function onAggiungiNotaDaPostare(params) {
    let documentoID = (params.file.document_id) ? params.file.document_id : params.file.documento_id;
    let elementiDelQuestionario = cloneDeep(risposteDelQuestionario.value);
    Object.keys(elementiDelQuestionario).forEach(function(elementKey) {
      if(elementiDelQuestionario[elementKey].value) {
        (elementiDelQuestionario[elementKey].value).forEach(function(value) {
          let valueDocumentID = (value.document_id) ? value.document_id : value.documento_id;
          if(valueDocumentID === documentoID) {
            value.notaAggiunta = params.value;
          }
        })
      }
    });

    risposteDelQuestionario.value = elementiDelQuestionario
  }

  async function onInviaNotaDiUnFile(params) {
    let documentoID = (params.file.document_id) ? params.file.document_id : params.file.documento_id;
    let postaNotaDoc = await httpPost('Questionario','postaNotaDoc', {
      documento_id: parseInt(documentoID),
      questionario_id: questionarioIdAttivo.value,
      nota: params.value,
      pratica_id: praticaStore.praticaID
    }, {
      headers: { "Content-Type": "multipart/form-data" }, loading: false
    });

    let elementiDelQuestionario = cloneDeep(risposteDelQuestionario.value);
    let elementoRicercato = Questionario._searchByHash(elementiDelQuestionario, {el:params.element});

    if(params.file) {
      elementoRicercato['value'].forEach(function (element) {
        if((element.document_id === documentoID)  || (element.documento_id === documentoID)) {
          Object.keys(element).forEach(function(elementKey) {
            if(params.file[elementKey] !== undefined) {
              element[elementKey] = params.file[elementKey];
            }

            if(elementKey === 'notaAggiunta') {
              element[elementKey] = null;
            }

            if(elementKey === 'note') {
              let noteDocSize = (Object.keys(postaNotaDoc.note).length) - 1;
              if(!element[elementKey]) {
                element[elementKey] = [];
              }
              element[elementKey].push(postaNotaDoc.note[noteDocSize]);
            }
          });
        }
      });
    }

    risposteDelQuestionario.value = elementiDelQuestionario
  }

  function onAggiornaElementoInQuestionario(params) {
    let elementoDaAggiornare = cloneDeep(risposteDelQuestionario.value[params.index])
    elementoDaAggiornare.value = params.value;
    risposteDelQuestionario.value = elementoDaAggiornare
  }

  /**
   * Esegue una chiamata Ajax per recuperarsi i jSON dei questionari lato front per il soggetto loggato e la pratica selezionata
   * @param fnParams
   */
  async function getQuestionariFront(fnParams) {
    if (praticaStore.praticaID) {
      let requestParams = {
        "pratica_id": praticaStore.praticaID
      };

      if(fnParams && fnParams['completato'] !== undefined) {
        requestParams.completato = fnParams.completato;
      }

      if (fnParams && fnParams['soggettoId'] !== undefined) {
        requestParams.soggetto_id = fnParams.soggettoId;
      }

      if (fnParams && fnParams['questionarioId'] !== undefined) {
        requestParams.questionario_id = fnParams.questionarioId;
      }

      await onResponseQuestionariRichiesti({init: false, objectToRequest: requestParams});
    }
  }

  return { questionarioTemplate, questionarioAttivo, questionarioAttivoStatus, questionari, questionario, questionariRichiesti, notaioDaFare, cittadinoDaFare, checkList, isQuestionariDaCompletare, controlloDisabilitaPerBottoneValidazione, risposteDelQuestionario, questionarioDefault, questionarioIdAttivo, is_show_checklist,
    reloadQuestionariRichiestiPerSoggetto, onResponseQuestionariRichiesti, getChecklist, getQuestionariFront,onAggiungiNotaDaPostare, onAggiornaElementoInQuestionario, onInviaNotaDiUnFile, onReInitQuestionario, onControlloDisabilitaPerCtaCompletaValidazione
  }
})